
import { supabase } from "@/integrations/supabase/client";
import { useEffect, useState } from "react";

interface EmailFetcherProps {
  isUpdatePassword: boolean;
  onEmailFetched: (email: string | null) => void;
}

export const useEmailFetcher = ({ 
  isUpdatePassword, 
  onEmailFetched 
}: EmailFetcherProps) => {
  useEffect(() => {
    const getUserEmail = async () => {
      if (isUpdatePassword) {
        try {
          const { data: { user } } = await supabase.auth.getUser();
          if (user?.email) {
            onEmailFetched(user.email);
          }
        } catch (error) {
          console.error("Error getting user email:", error);
        }
      }
    };
    
    getUserEmail();
  }, [isUpdatePassword, onEmailFetched]);
};
